module.exports = __webpack_public_path__ + "media/bootstrap-icons/clipboard-plus-79398ca0.svg";